import Parse from 'parse';
import { wrapRESTController } from './util/parseRESTWrapper';

Parse.initialize(process.env.REACT_APP_PARSE_ID || '');
Parse.serverURL = process.env.REACT_APP_PARSE_URL || '';

// @ts-ignore
Parse.CoreManager.setRESTController(wrapRESTController(Parse.CoreManager.getRESTController()));
